import { useContext } from 'react';

import { AddQBankStructureToQConfigGeneratorProviderContext } from './add-qbank-structure-to-qconfig-generator-provider';

export function useAddQBankStructureToQConfigGenerator() {
  const context = useContext(AddQBankStructureToQConfigGeneratorProviderContext);

  if (!context) {
    throw new Error(
      'useAddQBank must be used within an AddQBankStructureToQConfigGeneratorProvider',
    );
  }

  return context;
}
